import { truncate } from 'lodash';
/**
 * Article Card Sizes
 */
export const articleCardSizes = {
  default: {
    width: '190px',
    height: '106px',
  },
  defaultMobile: {
    width: '120px',
    height: '68px',
    class: 'text-xl',
  },
  sm: {
    width: '170px',
    height: '96px',
  },
  md: {
    width: '200px',
    height: '113px',
  },
  lg: {
    width: '300px',
    height: '169px',
  },
  full: {
    width: '100%',
    height: 'auto',
  },
};

/**
 * Article Card Description
 *
 * Case 1: Başlık max 77 karakter ise, açıklama max 3 nokta dahil 92 karakter olmalıdır.
 * Case 2: Başlık max 114 karakter ise, açıklama max 3 nokta dahil 54 karakter olmalıdır.
 *
 * @param {Object} article
 */
export function getArticleDescription(article) {
  let descriptionMaxLength = 0;

  // decsription yoksa
  if (!article.description) {
    return null;
  }

  // title cok uzunsa
  if (article.title.length > 114) {
    return null;
  }

  // Case 2: Başlık max 114 karakter ise, açıklama max 3 nokta dahil 54 karakter olmalıdır.
  if (article.title.length <= 114) {
    descriptionMaxLength = 54 - 3;
  }

  // Case 1: Başlık max 77 karakter ise, açıklama max 3 nokta dahil 92 karakter olmalıdır.
  if (article.title.length <= 77) {
    descriptionMaxLength = 92 - 3;
  }

  return truncate(article.description, { length: descriptionMaxLength });
}
